import Vue from "vue";
import VueI18n from "vue-i18n";
import elementZhCN from "element-ui/lib/locale/lang/zh-CN";
import elementEnUS from "element-ui/lib/locale/lang/en";
import elementZhTW from "element-ui/lib/locale/lang/zh-TW";
import zhCN from "./locales/zh-CN";
import enUS from "./locales/en-US";
import yue from "./locales/yue";

Vue.use(VueI18n);

export const SUPPORTED_LOCALES = ["zh-CN", "en-US", "yue"];
export const LOCALE_STORAGE_KEY = "comic-ai-locale";

export function normalizeLocale(locale) {
  const value = String(locale || "").toLowerCase();
  if (value.startsWith("en")) {
    return "en-US";
  }
  if (
    value.startsWith("yue") ||
    value.startsWith("zh-hk") ||
    value.startsWith("zh-mo")
  ) {
    return "yue";
  }
  return "zh-CN";
}

function getStoredLocale() {
  if (typeof window === "undefined" || !window.localStorage) {
    return "";
  }
  return window.localStorage.getItem(LOCALE_STORAGE_KEY) || "";
}

function getInitialLocale() {
  // 用户手动切换过的语言优先于环境默认值，刷新后保持当前选择
  const storedLocale = getStoredLocale();
  if (storedLocale) {
    return normalizeLocale(storedLocale);
  }
  const configuredLocale = process.env.VUE_APP_LOCALE;
  if (configuredLocale) {
    return normalizeLocale(configuredLocale);
  }
  if (typeof navigator !== "undefined") {
    return normalizeLocale(navigator.language);
  }
  return "zh-CN";
}

export const i18n = new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: "zh-CN",
  silentFallbackWarn: true,
  messages: {
    "zh-CN": {
      ...elementZhCN,
      ...zhCN,
    },
    "en-US": {
      ...elementEnUS,
      ...enUS,
    },
    yue: {
      ...elementZhTW,
      ...yue,
    },
  },
});

export function setLocale(locale) {
  const resolvedLocale = normalizeLocale(locale);
  i18n.locale = resolvedLocale;

  if (typeof document !== "undefined") {
    document.documentElement.lang = resolvedLocale;
  }
  if (typeof window !== "undefined") {
    if (window.localStorage) {
      window.localStorage.setItem(LOCALE_STORAGE_KEY, resolvedLocale);
    }
    window.dispatchEvent(
      new CustomEvent("app-locale-changed", {
        detail: { locale: resolvedLocale },
      }),
    );
  }

  return resolvedLocale;
}

setLocale(i18n.locale);

export default i18n;
